<glxy-page [isLoading]="isLoading()">
  <glxy-page-toolbar>
    <glxy-page-title>{{ 'INBOX.SETTINGS.WEBCHAT_CONFIGURATION' | translate }}</glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper widthPreset="narrow">
    <inbox-webchat-form
      #webchatFormComponent
      (formChange)="updateFormData($event)"
      (customKnowledgeFormChange)="updateCustomKnowledgeFormData($event)"
      (knowledgeSourcesChange)="updateKnowledgeSources($event)"
      [disabled]="isLoading()"
    ></inbox-webchat-form>

    <inbox-sticky-footer
      [submitOverride]="'INBOX.NEXT' | translate"
      (submitClick)="createWebchat()"
      [cancelLink]="backUrl"
      [disabled]="isLoading()"
    ></inbox-sticky-footer>
  </glxy-page-wrapper>
</glxy-page>
